import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { Box } from "../AHTheme/Box";

export function TextIcon(props: { color?: string; absoluteSize: number }) {
  return (
    <Box
      style={{
        height: props.absoluteSize,
        width: props.absoluteSize,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TextIconSvg color={props.color} />
    </Box>
  );
}

export function TextIconSvg(props: { color?: string }) {
  return (
    <Svg viewBox="0 0 24 24">
      <Path
        fill={props.color ?? "#FFF"}
        d="m17.468 13.944v1.312h-4.96v-1.312h4.96z"
      />
      <Path
        fill={props.color ?? "#FFF"}
        d="m9.9216 12.624h-2.096l-0.336 0.992h-1.432l2.032-5.616h1.584l2.032 5.616h-1.448l-0.33598-0.992zm-0.352-1.056-0.696-2.056-0.688 2.056h1.384z"
      />
    </Svg>
  );
}
